import {
  GeneralRequirementType,
  IPayerResponse,
  PayeeTaxDocumentSharePermission,
  RequirementStatus,
  VerificationStatus
} from "@wingspanhq/payments/dist/interfaces";
import {
  CustomRequirementType,
  ExtendedRequirementItem
} from "../modules/GeneralRequirements/types";
import { usePaymentsStatusQuery } from "../../../query/payments/queries";
import { useQueryVerifications } from "../../../query/onboarding/queries/useQueryVerifications";

export const usePayerExtendedGeneralRequirements = (
  payer: IPayerResponse
): {
  requirements: ExtendedRequirementItem[];
  isLoading: boolean;
} => {
  const queryPaymentsSettings = usePaymentsStatusQuery();
  const oldTaxInfoStatus =
    queryPaymentsSettings.data?.verifications.taxDocumentation;

  const queryVerifications = useQueryVerifications();
  const taxInfoStatus = queryVerifications.data?.tax;

  return {
    requirements: [
      {
        requirementType: GeneralRequirementType.Registration,
        status:
          payer?.requirements?.find(
            r => r.requirementType === GeneralRequirementType.Registration
          )?.status || RequirementStatus.Incomplete
      },
      {
        requirementType: GeneralRequirementType.PayoutMethod,
        status:
          payer?.requirements?.find(
            r => r.requirementType === GeneralRequirementType.PayoutMethod
          )?.status || RequirementStatus.Incomplete
      },
      {
        requirementType: CustomRequirementType.TaxForm,
        status: [oldTaxInfoStatus, taxInfoStatus].includes(
          VerificationStatus.Verified
        )
          ? RequirementStatus.Complete
          : RequirementStatus.Incomplete
      },
      {
        requirementType: CustomRequirementType.InfoShare,
        status:
          payer?.payeeOwnedData.shareTaxDocument ===
          PayeeTaxDocumentSharePermission.Allow
            ? RequirementStatus.Complete
            : RequirementStatus.Incomplete,
        // need for share tax document
        payerId: payer.payerId
      }
    ],
    isLoading:
      !payer || queryPaymentsSettings.isLoading || queryVerifications.isLoading
  };
};
